import React from 'react';
import { useTheme } from 'styled-components';

import { useTranslate } from '@/translations';
import { PageContainer, Title, faCarBurst } from '@/ui/components';

import { InspectionsDataGrid } from './components';

export const Inspections = () => {
  const { t } = useTranslate();
  const { accent } = useTheme();

  return (
    <PageContainer>
      <Title title={t('inspectionSearch')} icon={faCarBurst} color={accent} />

      <InspectionsDataGrid />
    </PageContainer>
  );
};
